//COPIED FROM CONFLUENCE

import { getRte } from '../../facades/editor';
import { addEventListener } from '../../facades/document';
import window from 'window-or-global';
import { bind, trigger, unbind } from '@confluence-classic/confluence-event_DO_NOT_USE';

// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

// Stylesheet.
require('./css/property-panel.css');

/**
 * Confluence property panels for images and links.
 */
const plugin = () => {
	const PropertyPanel = window.Confluence.PropertyPanel;
	const handlers = [];
	bind('add-handler.property-panel', (e, data) => {
		data && handlers.push(data);
	});

	return {
		init: (ed) => {
			const isPanelShowing = () => {
				return !!PropertyPanel.current;
			};
			/*
             A single selection event might have several contexts:
             - No current property panel
             -- Selected element that DOESN'T fire a panel
             -- Selected element that DOES fire a panel
             - Current property panel
             -- Selected element that DOESN'T fire a panel
             -- Selected element that DOES fire a panel
             --- Selected the anchor of the CURRENT property panel
             --- Selected a different element that DOES fire a panel
             ---- Selected a different element that DOES fire a panel of the SAME type
             ---- Selected a different element that DOES fire a panel of a DIFFERENT type

             To begin with it will be the responsibility of the element-specific code (img/a/etc) to determine the context;
             if enough overlap between IMG and A is found it can be centralized here.
             */

			let boundElement;
			const isToolBarShowing = () => {
				return !!$('.toolbar-contextual').length;
			};
			const isElementInTable = (el) => {
				return !!el.closest('table:not(.wysiwyg-macro,.editor-inline-macro)').length;
			};
			const isRightClick = (e) => {
				if (e.type != 'click') {
					return false;
				}
				if (e.which) {
					return e.which === 3;
				}
				if (e.button) {
					return e.button == 2;
				}
			};
			const getClosestAnchor = ($element) => {
				if ($element.is('img')) {
					return $element[0];
				}

				// WTF - everything is pluggable but this...
				const closest = $element.closest(
					'a,table,.wysiwyg-macro,.editor-inline-macro,.text-placeholder',
				);
				if (closest.length) {
					return closest[0];
				}

				return '';
			};
			const handler = (e, focusedEl) => {
				const data = {
					focusedEl,
					focusedNodeName: focusedEl.nodeName && focusedEl.nodeName.toLowerCase(),
					ed,
					e: $.extend({}, e), //lookds odd, but is needed for what appears to be a GC bug in ie8/9
				};
				const containerEl = getClosestAnchor($(focusedEl));
				const isInTable = isElementInTable($(focusedEl));
				const toolbarActive = isToolBarShowing();
				data.containerEl = containerEl;

				trigger('user-blurred-rte-element', data);
				if (containerEl && !isRightClick(e) && !isPanelShowing() && PropertyPanel.shouldCreate) {
					for (let i = 0, len = handlers.length; i < len; i++) {
						if (handlers[i].canHandleElement($(containerEl))) {
							if (toolbarActive || !isInTable) {
								return handlers[i].handle(data);
							}
							//this now means that you get no return.
							//if this becomes a problem we could use a promise
							((handler) => {
								// FOXY TODO: memory leak here CONFDEV-53288
								// not sure how this plugin works yet so leaving as is for now
								addEventListener('shown.contextToolbar', () => {
									handler.handle(data);
								});
							})(handlers[i]);
						}
					}
				}
			};

			/* All versions of IE apply drag/resize handles
			 * (those white dots along the edges of elements)
			 * to select elements in contentEditable regions that prevent the normal click
			 * event from propagating.
			 * Here, we're going to work around that fact.
			 */
			if (window.tinymce.Env.ie) {
				ed.on('MouseDown', (e) => {
					// Avoid memory leaks; kill any previous bound events.
					// Bound to a custom namespace to avoid clobbering other click events.
					boundElement && boundElement.unbind('mouseup.IEDragHandlesWorkaround');
					boundElement = $(e.target);
					// IE's drag/resize handles are applied to tables and images.
					boundElement.filter('img, table').bind('mouseup.IEDragHandlesWorkaround', () => {
						handler(ed, e, e.target);
					});
				});
			}

			ed.on('Click', (e) => {
				handler(e, e.target);
			});
			ed.on(
				'KeyUp',
				(e) => {
					if (e.keyCode === 27) {
						return;
					} // ignore esc, it's handled by keydown listener
					handler(e, ed.selection.getNode());
				},
				true,
			);
			ed.on('ContextMenu', () => {
				// destroy property panel when a context menu is shown
				PropertyPanel.destroy();
			});

			function handlerTriggerPropPanel(e, data) {
				handler(e, data.elem);
			}
			bind('trigger.property-panel', handlerTriggerPropPanel);

			function handlerUserBlurredRteElement(e, data) {
				e; // linter - unsused var
				if (isPanelShowing()) {
					if (!data.containerEl || PropertyPanel.current.hasAnchorChanged(data.containerEl)) {
						PropertyPanel.destroy();
					} else {
						trigger('same-anchor.property-panel');
					}
				}
			}
			bind('user-blurred-rte-element', handlerUserBlurredRteElement);

			function handlerCreatedPropPanel() {
				// Need to defer (for IE) and activating the property panel can cause an initial scroll event to fire that we want to miss.
				setTimeout(() => {
					// TODO: we can factor this out when we have all the deps in master.
					getRte().bindScroll('property-panel', () => {
						PropertyPanel.destroy();
					});
				}, 0);
				$(ed.getDoc()).bind('keydown.property-panel.escape', (e) => {
					if (e.keyCode === 27 && isPanelShowing()) {
						// esc key
						PropertyPanel.destroy();
					}
				});
			}
			bind('created.property-panel', handlerCreatedPropPanel);

			function handlerDestroyedPropPanel() {
				getRte().unbindScroll('property-panel');
				$(ed.getDoc()).unbind('keydown.property-panel.escape');
			}
			bind('destroyed.property-panel', handlerDestroyedPropPanel);

			//CONFDEV-55148
			ed.on('Remove', () => {
				unbind('trigger.property-panel', handlerTriggerPropPanel);
				unbind('user-blurred-rte-element', handlerUserBlurredRteElement);
				unbind('created.property-panel', handlerCreatedPropPanel);
				unbind('destroyed.property-panel', handlerDestroyedPropPanel);
			});
		},

		getInfo: () => {
			return {
				longname: 'Image, Link and Macro Property Panels',
				author: 'Atlassian',
				authorurl: 'http://www.atlassian.com',
				version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
			};
		},
	};
};

export default () => {
	window.tinymce.create('tinymce.plugins.PropertyPanel', plugin());
	window.tinymce.PluginManager.add('propertypanel', window.tinymce.plugins.PropertyPanel);
};
